import { API } from "../../../utils";

export const getClientAccountsList = async (query) => {
  const res = await API.get(`client-accounts-new-flow`, query);
  return res.data;
};

export const getClientAccountsDetailsByID = async (id) => {
  const res = await API.get(`client-accounts-new-flow/${id}`);
  return res.data;
};

export const createClientAccount = async (payload) => {
  const res = await API.post(
    `client-accounts-new-flow`,
    payload
  );
  return res.data;
};

export const updateClientAccount = async (id, payload) => {
  const res = await API.put(
    `client-accounts-new-flow/${id}`,
    payload
  );
  return res.data;
};

export const getClientAccountsAddressApi = async (id) => {
  const res = await API.get(
    `client-account-address/${id}/address-list`
  );
  return res.data;
};

export const createClientAccountsAddressApi = async (payload) => {
  const res = await API.post(`client-account-address`, payload);
  return res.data;
};

export const updateClientAccountsAddressApi = async (payload, id) => {
  const res = await API.put(
    `client-account-address/${id}`,
    payload
  );
  return res.data;
};

export const deleteClientAccountsAddressApi = async (id) => {
  const res = await API.delete(`client-account-address/${id}`);
  return res.data;
};

export const changeClientAccountsAddressDefaultApi = async (id) => {
  const res = await API.post(
    `client-account-address/${id}/set-default`
  );
  return res.data;
};

export const changeClientAccountsStatusApi = async (id) => {
  const res = await API.post(
    `client-accounts-new-flow/${id}/change-status`
  );
  return res.data;
}

/// Transactions APIs

export const getClientAccountTransactionsListApi = async (id, params) => {
  const res = await API.get(
    `client-account-transaction/${id}/transaction-list`,
    params
  );
  return res.data;
};

export const sendInvoiceApi = async (payload) => {
  const res = await API.post(
    `client-account/send-invoice`,
    payload
  );
  return res.data;
};

export const sendMutlipleInvoiceApi = async (id, payload) => {
  const res = await API.post(
    `orders/${id}/multiple-send-invoice`,
    payload
  );
  return res.data;
};

// sendInvoiceby id

export const sendInvoiceApibyID = async (id, tId, payload) => {
  const res = await API.post(
    `client-account/${id}/send-settlement/${tId}`,
    payload
  );
  return res.data;
};

export const getClientAccountTransactionDetailsApi = async (id) => {
  const res = await API.get(`client-account-transaction/${id}`);
  return res.data;
};

export const downloadTransactionDetailsPDF = async (id, tid) => {
  const res = await API.get(
    `client-account/${id}/download-settlement/${tid}`,
    {
      responseType: "blob",
    }
  );
  return res;
};

export const sendTransactionEmailApi = async (id, payload) => {
  const res = await API.post(
    `client-account-transaction/${id}/send-settlement`,
    payload
  );
  return res.data;
};

export const revertPaymentApi = async (id, payload) => {
  const res = await API.post(
    `client-account-transaction/${id}/revert-payment`,
    payload
  );
  return res.data;
};

export const assignCustomersToClinetAccount = async (id, payload) => {
  const res = await API.post(
    `client-accounts-new-flow/stores/${id}/add-customer`,
    payload
  );
  return res.data;
};

export const createClinetAccountSettlement = async (id, payload) => {
  const res = await API.post(
    `client-account-transaction/${id}/make-settlement`,
    payload
  );
  return res.data;
};
export const getPurchasedData = async (id) => {
  const res = await API.get(
    `client-account-transaction/${id}/purchase-list`
  );
  return res.data;
};

// =========================================== CLIENT ACCOUNT STATEMENT APIS ===============================================
export const getClientAccountStatementListApi = async ({
  clientAccountId,
  params,
}) => {
  const response = await API.get(
    `client-account-statement/${clientAccountId}/statement-list`,
    {
      params,
    }
  );
  return response.data;
};

export const getClientAccountStatementApi = async ({ statementId }) => {
  const response = await API.get(
    `client-account-statement/${statementId}`
  );

  return response.data;
};

export const downloadClientAccountStatementApi = async ({
  clientId,
  statementId,
}) => {
  const response = await API.get(
    `client-account/${clientId}/download-statement/${statementId}`,
    {
      responseType: "blob",
    }
  );
  return response;
};

export const sendClientAccountStatementApi = async ({
  clientId,
  emails,
  statementId,
}) => {
  const response = await API.post(
    `client-account/${clientId}/send-statement/${statementId}`,
    { emails }
  );
  return response.data;
};

// ================================================ ON DEMAND STATEMENT APIS ===============================================

export const getOnDemandStatementApi = async ({ clientId, params }) => {
  const response = await API.get(
    `client-account-statement/${clientId}/demand-statement-list`,
    {
      params,
    }
  );

  return response.data;
};

export const downloadOnDemandStatementApi = async ({ clientId, params }) => {
  const response = await API.get(
    `client-account/${clientId}/download-demand-statement/`,
    {
      params,
      responseType: "blob",
    }
  );
  return response;
};

export const sendOnDemandStatementApi = async ({ clientId, data }) => {
  const response = await API.post(
    `client-account/${clientId}/send-demand-statement`,
    data
  );
  return response.data;
};

// =========================================== CLIENT ACCOUNT REQUESTS APIS ===============================================

export const getClientAccountRequestsApi = async (params) => {
  const response = await API.get("client-account-request", {
    params,
  });
  return response.data;
};

export const sendClientAccountCreateInviteApi = async (data) => {
  const response = await API.post(
    "client-account-request/send-invite",
    data
  );
  return response.data;
};

export const getClientAccountRequestDetailsApi = async (requestId) => {
  const response = await API.get(
    `client-account-request/${requestId}`
  );
  return response.data;
};

export const rejectClientAccountRequestApi = async ({ requestId, payload }) => {
  const response = await API.post(
    `client-account-request/${requestId}`,
    payload
  );
  return response.data;
};

export const approveClientAccountRequestApi = async ({
  requestId,
  payload,
}) => {
  const response = await API.put(
    `client-account-request/${requestId}`,
    payload
  );
  return response.data;
};

export const getOrderDetailsById = async (id) => {
  const res = await API.get(`orders/${id}`);
  return res.data;
};